import { Component, Inject, OnInit } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormBuilder, FormControl } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StatusConstant } from '../status/status-constant';
import { LoaderService } from '../../shared/loader/loader.service';
import { Observable } from 'rxjs/internal/Observable';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../reusableComponents/confirm-dialog/confirm-dialog.component';
import { Clipboard } from "@angular/cdk/clipboard";
import { FormAuditType, ProjectTempType } from '../Enum/common.enum';
import { GroupType } from 'src/app/applicationModules/core/services/coreService/core.enum';
import { DataSharingService } from '../resuableServices/data-sharing.service';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Add3ctypeformComponent } from '../add3ctypeform/add3ctypeform.component';
import { map, retry, startWith } from 'rxjs/operators';
import { MatSelectChange } from '@angular/material/select';
export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}
@Component({
  selector: 'app-mergeForms',
  templateUrl: './mergeForms.component.html',
  styleUrls: ['./mergeForms.component.scss'],
})

export class MergeFormsComponent implements OnInit {
  organizationId: any;
  databaseId: any;
  currentUser: any;
  responseHolder: any;
  spinner: boolean = false;
  OfficeIDList: any = [];
  myOfficeID: any;
  getassign: any;
  SendButtonDisabled: boolean = false;
  SendButtonDisabledForQuickSend: boolean = true;
  NormalContacts: any = [];
  SharedContacts: any = [];
  MatchingRole: any = [];
  projectGroups: any = [] = [];
  participantMessageInfo: string = '';
  ProjectIdForEdit: string = "";
  projectID: number = 0;
  eventLogMessage: string = "";
  toogleInformation = true;
  ipAddress: any;
  browsername: any;
  device: any;
  ContactNames: string = "";
  totalForms: number = 0;
  sharedCoreList: any = [] = [];
  sharedContactList: any = [] = [];
  sharedCompanyList: any = [] = [];
  projGrpRelationParticipantListNew: any = [] = [];
  placeholderName: string = "";
  currentIndex: number = 0;
  projectGroupsCache: any = [] = [];

  isSharedAccessRolePopup: boolean = false;
  isRolePopup: boolean = false;
  contactsList: any = [];
  selectedsharedAccessRole: any = [];
  showAddButton = false;
  Module: string = '';
  showAddContact: boolean = false;
  sharedAccessRoleList: any = [];
  SharedRoleList: any = [];
  Roles: any = [];
  showContactRoleAddButton = false;
  documentId: number = 0;
  coreID: any;
  isReviewerPopup: boolean = true;
  selectedUser: boolean = false;
  userSelectedList: any = [];
  isSharedAccessUserPopup: boolean = false;
  sharedAccessUserList: any = [];
  peoples: any = [];
  groupID: number = 0;
  groupType: any;
  groupRelationParticipantMappingID: number = 0;
  relationColour: string = '';
  relationID: number = 0;
  isShare: boolean = false;
  contactemail: any;
  currentRoleContact: any;
  transRoleList: any = [];
  type: number = 0;
  searchValues: string = "";
  FirstTime: boolean = true;
  projectIDs: number[] = [];
  AllParticipantsProjectsList: any = [] = [];

  constructor(public dialogRef: MatDialogRef<MergeFormsComponent>,
    private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private coreService: CoreService,
    private toastr: ToastrService, private statusConstant: StatusConstant,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private loaderService: LoaderService, private dialog: MatDialog,
    private clipboard: Clipboard, private _dataSharingService: DataSharingService,
    private http: HttpClient, private httpBackend: HttpBackend,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList') || '[]');
    offices.forEach((oe: any) => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    var skipInterceptor = new HttpClient(httpBackend);
    skipInterceptor.get<{ ip: string }>('https://api.ipify.org?format=json').subscribe(data => {
      this.ipAddress = data.ip
    });
    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''),
      map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );
  }

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state: any) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  ngOnInit(): void {
    this.projectIDs = [];
    this.getassign = this.data.document;
    this.SendButtonDisabled = false;
    this.SendButtonDisabledForQuickSend=true;
    this.totalForms = this.data.document.length;
    this.GetAllParticipantsForProjects();
    this.getNormalAndSharedContacts(this.data.document[0].selectedDocument, 0);
    this.getSharedCores();
    this.getSharedContacts();
    this.getSharedCompanys();
  }

  GetAllParticipantsForProjects() {

    const projectList = (this.data.document || []).map((item: any) => ({
      projectID: item?.selectedDocument?.projectID,
      projectName: item?.selectedDocument?.placeholderName
    })).filter((p: any) => p.projectID); //  safety

    const projectIDs = projectList.map((p: any) => p.projectID);

    const reqModel = {
      projectIDs: projectIDs,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId)
    };

    this.loaderService.show();

    this.coreService.getAllParticipantsForProjects(reqModel).subscribe(response => {

      this.loaderService.hide();

      if (response && response.status === this.statusConstant.statusSuccess) {

        const apiData = response.data;

        //  handle empty safely
        const allParticipants = apiData || [];

        this.AllParticipantsProjectsList = projectList.map((project: any) => {

          //  directly filter participants
          const participants = allParticipants.filter((p: any) => p.projectID === project.projectID);

          return {
            projectID: project.projectID,
            projectName: project.projectName,                   
            projGrpRelationParticipantList: participants
          };
        });

        this.AllParticipantsProjectsList;
        var checks:any=[]=[];
        checks=allParticipants.filter((x:any)=> x.participantEmail !="");
        if(checks.length>0){
          this.SendButtonDisabledForQuickSend=false;
        }else{
           this.SendButtonDisabledForQuickSend=true;
        }

      } else {
        this.AllParticipantsProjectsList = [];
      }

    }, error => {
      this.loaderService.hide();
      this.AllParticipantsProjectsList = [];
    });
  }


  getSharedCores() {
    var reqModel = {
      coreID: Number(this.data.transactionID),
      pageIndex: 0,
      pageSize: 10,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId)
    }
    this.coreService.getCoreSelectedCores(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.sharedCoreList = response.data.coreListModel;
          if (this.sharedCoreList == null) {
            this.sharedCoreList = [];
          }
        } else {
          this.sharedCoreList = [];
        }
      }
      else {
        this.sharedCoreList = [];
      }
    });
  }

  getSharedContacts() {
    var reqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      coreID: Number(this.data.transactionID),
      officeID: this.myOfficeID
    }
    this.coreService.getNormalAndSharedContacts(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.sharedContactList = response.data.contactListModel;
        } else {
          this.sharedContactList = [];
        }
      }
      else {
        this.sharedContactList = [];
      }
    });
  }

  getSharedCompanys() {
    var reqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      coreID: Number(this.data.transactionID),
      officeID: this.myOfficeID
    }
    this.coreService.getNormalAndSharedCompanys(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.sharedCompanyList = response.data.companyListModel;
        } else {
          this.sharedCompanyList = [];
        }
      }
      else {
        this.sharedCompanyList = [];
      }
    });
  }


  getNormalAndSharedContacts(document: any, index: any) {
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      coreID: Number(this.data.transactionID)
    }
    this.coreService.getNormalAndSharedContacts(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.MatchingRole = [];
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.NormalContacts = response.data.contactListModel.filter((x: any) => x.contactCoreRoleMappingModels.length > 0);
          if (this.NormalContacts.length > 0) {
            for (var i = 0, len = this.NormalContacts.length; i < len; ++i) {
              var contactCoreRoleMappingModels = [];
              contactCoreRoleMappingModels = this.NormalContacts[i].contactCoreRoleMappingModels;
              if (contactCoreRoleMappingModels.length > 0) {
                for (var i1 = 0, len1 = contactCoreRoleMappingModels.length; i1 < len1; ++i1) {
                  var ReqModel = {
                    contactID: this.NormalContacts[i].contactID,
                    email: this.NormalContacts[i].email,
                    name: this.NormalContacts[i].name,
                    roleName: contactCoreRoleMappingModels[i1].rloeName
                  }
                  this.MatchingRole.push(ReqModel);
                }
              }
              else {
              }
            }

          }

          this.SharedContacts = response.data.sharedContactListModel.filter((x: any) => x.contactCoreRoleMappingModels.length > 0);

          if (this.SharedContacts.length > 0) {

            for (var i = 0, len = this.SharedContacts.length; i < len; ++i) {
              var contactCoreRoleMappingModels = [];
              contactCoreRoleMappingModels = this.SharedContacts[i].contactCoreRoleMappingModels;
              if (contactCoreRoleMappingModels.length > 0) {
                for (var i1 = 0, len1 = contactCoreRoleMappingModels.length; i1 < len1; ++i1) {
                  var ReqModel = {
                    contactID: this.SharedContacts[i].contactID,
                    email: this.SharedContacts[i].email,
                    name: this.SharedContacts[i].name,
                    roleName: contactCoreRoleMappingModels[i1].rloeName
                  }
                  this.MatchingRole.push(ReqModel);
                }
              }
              else {
              }
            }
          }
          this.AddCreateProjectforPlaceholder(document, index)
        } else {
        }
      }
      else {
      }
    });
  }


  AddCreateProjectforPlaceholder(document: any, index: number) {
    this.projectGroups = [];
    this.placeholderName = document.placeholderName;
    var ReqModel = {
      transactionID: Number(this.data.transactionID),
      documentFolderID: document.documentFolderID,
      formID: document.formID,
      formType: FormAuditType.NormalForm,
      placeholderID: document.placeholderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      taskID: document.taskID,
      projectID: document.projectID
    }
    this.loaderService.show();
    this.coreService.AddCreateProjectforPlaceholder(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.projectGroups = this.responseHolder.data.participants || [];
          if (this.projectGroups == null) {
            this.projectGroups = [];
          }

          if (this.projectGroups.length > 0) {
            this.participantMessageInfo = this.projectGroups[0].participantMessageInfo;

            for (var i = 0, lennew = this.projectGroups.length; i < lennew; ++i) {
              // this.projectGroups[i].projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList.filter(m => m.isApprover != true);
              this.projectGroups[i].projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList;
            }
            for (var i = 0, lennew = this.projectGroups.length; i < lennew; ++i) {
              var projGrpRelationParticipantList: any = [] = [];
              projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var matchRole = [];
                  matchRole = this.MatchingRole.filter((m: any) => m.roleName == projGrpRelationParticipantList[i1].relationName);
                  if (matchRole.length > 0) {
                    this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID = matchRole;
                  } else {
                    this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID = [];
                  }
                }
              }
              else {
              }
            }
          }


          if (this.projectGroups.length > 0) {
            this.ProjectIdForEdit = this.projectGroups[0].projectID;
            this.projectID = this.projectGroups[0].projectID;
          }

          if (this.projectGroups.length > 0) {
            this.projGrpRelationParticipantListNew =
              (response.data?.participants || [])
                .filter((group: any) => group.projGrpRelationParticipantList?.length > 0)
                .flatMap((group: any) => group.projGrpRelationParticipantList);

            if (this.FirstTime == true) {
              //  STORE DATA IN CACHE             
              this.projectGroupsCache[index] = JSON.parse(JSON.stringify(this.projGrpRelationParticipantListNew));
            }

            if (this.FirstTime === false) {

              this.projGrpRelationParticipantListNew =
                this.projGrpRelationParticipantListNew.map((item: any) => {

                  const allCachedList = (this.projectGroupsCache || []).flat();

                  const checkContactEmail = item.contactEmail?.trim();
                  const checkParticipantEmail = item.participantEmail?.trim();

                  // Run only if both emails are empty
                  if (!checkContactEmail && !checkParticipantEmail) {

                    var matches: any = [] = [];
                    // Step 1: Get all matches based on type + relationName
                    matches = allCachedList.filter((cacheItem: any) =>
                      cacheItem.typeOfParticipant === item.typeOfParticipant &&
                      cacheItem.relationName.toLowerCase() === item.relationName.toLowerCase());

                    if (matches.length > 0) {

                      // Step 2: Prefer record where participantEmail is not blank
                      const selectedMatch = matches.find((m: any) => m.participantEmail?.trim()) || matches[0];

                      // Step 3: Call autofill
                      if (selectedMatch) {
                        this.groupRelationParticipantMappingID = item.groupRelationParticipantMappingID;
                        this.groupID = item.groupID;
                        this.relationID = item.relationID;
                        this.relationColour = item.relationColour;
                        this.projectID = this.projectID;

                        this.addUpdateParticipantsAutoFill(selectedMatch,item);
                      }
                    }
                  }
                  return item; // IMPORTANT: must return item in map
                });
            }

            // if (this.FirstTime == false) {
            //   //  Autofill only when roleName is blank
            //   this.projGrpRelationParticipantListNew =
            //     this.projGrpRelationParticipantListNew.map(item => {
            //       const allCachedList = (this.projectGroupsCache || []).flat();

            //       //  Check if relationName is blank/null/undefined              
            //       const checkContactEmail = item.contactEmail?.trim();
            //       const checkParticipantEmail = item.participantEmail?.trim();

            //       if (!checkContactEmail && !checkParticipantEmail) {

            //         const match = allCachedList.find(cacheItem =>
            //           cacheItem.typeOfParticipant === item.typeOfParticipant &&
            //           cacheItem.relationName == item.relationName // only match valid cached role
            //         );

            //         //  Call only if match found
            //         if (match) {
            //           this.groupRelationParticipantMappingID = item.groupRelationParticipantMappingID;
            //           this.groupID = item.groupID;
            //           this.relationID = item.relationID;
            //           this.relationColour = item.relationColour;
            //           this.projectID = this.projectID;
            //           this.addUpdateParticipantsAutoFill(match);
            //         }
            //       }

            //     });
            // }
          }


          this.projectGroupsCache[index] = JSON.parse(JSON.stringify(this.projGrpRelationParticipantListNew));

          // var data = [];
          // data = this.projectGroups;
          // if (data.length > 0) {
          //   this.eventLogMessage = "Sent for signature to ";
          //   var checkGroup = this.projectGroups.filter(m => m.groupType == GroupType.Group);
          //   if (checkGroup.length > 0) {
          //     var projGrpRelationParticipantList = [];
          //     projGrpRelationParticipantList = checkGroup[0].projGrpRelationParticipantList;
          //     for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
          //       var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
          //       var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
          //       var email = "";
          //       if (checkEmailAnonmous != "") {
          //         email = checkEmailAnonmous;
          //         this.eventLogMessage += '(' + email + '), ';
          //       }
          //       if (checkEmail != "") {
          //         email = checkEmail;
          //         this.eventLogMessage += '(' + email + '), ';
          //       }
          //     }
          //   }

          //   var checkViewOnly = this.projectGroups.filter(m => m.groupType == GroupType.ViewOnly);
          //   if (checkViewOnly.length > 0) {
          //     for (var i = 0, len4 = checkViewOnly.length; i < len4; ++i) {
          //       var projGrpRelationParticipantList = [];
          //       projGrpRelationParticipantList = checkViewOnly[i].projGrpRelationParticipantList;
          //       for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
          //         var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
          //         var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
          //         var email = "";
          //         if (checkEmailAnonmous != "") {
          //           email = checkEmailAnonmous;
          //           this.eventLogMessage += '(' + email + '), ';
          //         }
          //         if (checkEmail != "") {
          //           email = checkEmail;
          //           this.eventLogMessage += '(' + email + '), ';
          //         }
          //       }
          //     }
          //   }
          // }

          // this.eventLogMessage = this.eventLogMessage?.replace(/,\s*$/, "") || "";

          var check = [];
          if (this.responseHolder.data.participants == null) {
            this.responseHolder.data.participants = [];
          }
          check = this.responseHolder.data.participants.filter((x: any) => x.groupType === GroupType.Group);//this.responseHolder.data.filter((x:any) => x.groupType === 1);
          if (check.length > 0) {
            for (var i = 0, len = check.length; i < len; ++i) {
              var projGrpRelationParticipantList: any = [] = []
              projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  if (projGrpRelationParticipantList[i1].participantEmail == null) {
                    projGrpRelationParticipantList[i1].participantEmail = '';
                  }
                  if (projGrpRelationParticipantList[i1].coreID > 0 || projGrpRelationParticipantList[i1].contactID > 0 ||
                    projGrpRelationParticipantList[i1].companyID > 0 || projGrpRelationParticipantList[i1].pUserID > 0 ||
                    projGrpRelationParticipantList[i1].roleID > 0 || projGrpRelationParticipantList[i1].participantEmail != '')
                  // if (projGrpRelationParticipantList[i1].contactEmail != "" ||
                  //   projGrpRelationParticipantList[i1].participantEmail != "" ||
                  //   projGrpRelationParticipantList[i1].roleID != "0") 
                  {
                    this.SendButtonDisabled = true;
                    this.loaderService.hide();
                    return;
                  } else {
                    this.SendButtonDisabled = false;
                    // return;
                  }
                }
              }
              else {
              }
            }
          }

        } else {
          this.loaderService.hide();
          this.projectGroups = [];
          //this.dialog.closeAll();
        }
      } else {
        this.loaderService.hide();
        this.projectGroups = [];
        //this.dialog.closeAll();
      }
    });

  }

  goToNext() {
    this.FirstTime = false;
    this.saveCurrentState();

    if (this.currentIndex < this.totalForms - 1) {
      this.currentIndex++;
      this.loadFormByIndex(this.currentIndex);
    }
  }

  goToPrevious() {
    this.FirstTime = false;
    this.saveCurrentState();
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.loadFormByIndex(this.currentIndex);
    }
  }

  saveCurrentState() {
    this.projectGroupsCache[this.currentIndex] =
      (this.projectGroups || [])
        .filter((group: any) => group.projGrpRelationParticipantList?.length > 0)
        .flatMap((group: any) => group.projGrpRelationParticipantList)
        .map((p: any) => JSON.parse(JSON.stringify(p)));
  }


  loadFormByIndex(index: number) {
    const selectedDoc = this.data.document[index]?.selectedDocument;
    if (selectedDoc) {
      this.getNormalAndSharedContacts(selectedDoc, index);
    }
  }


  closeSelectParticipant() {
    this.projectGroupsCache = [];
    this.dialog.closeAll();
    //this.dialogRef.close('Added');
  }

  getToogleInformation() {
    this.toogleInformation = !this.toogleInformation;
  }

  getShortName(fullName: any) {
    return fullName.split(' ').map((n: any) => n[0]).join('');
  }

  openProject() {
    // this.dialog.closeAll();
    sessionStorage.setItem('projectID', this.ProjectIdForEdit);
    sessionStorage.setItem('type', (ProjectTempType.Project).toString()); // 1 for Project and 2 for Template
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateWebForm', 'false');
    this._dataSharingService.sendSelectedProjectName("");
    let links = window.location.href.split(window.location.pathname)[0] + "/esignature/third"
    window.open(links, "_blank");
    sessionStorage.setItem('HeaderModuleName', 'Forms');
    this._dataSharingService.sendSelectedModuleName('Forms');
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
  }


  ProjectSend() {
    const documents = this.data?.document || [];
    if (documents.length === 0) {
      this.toastr.warning('No forms available to send.');
      return;
    }
    this.loaderService.show();
    this.sendFormSequentially(documents, 0);
  }

  QuickProjectSend() {

    const projectList = (this.data.document || []).map((item: any) => ({
      projectID: item?.selectedDocument?.projectID,
      projectName: item?.selectedDocument?.placeholderName
    })).filter((p: any) => p.projectID); //  safety

    const projectIDs = projectList.map((p: any) => p.projectID);
    

    var participantsList:any=[]=[];
    var participants:any=[]=[];
   if(this.AllParticipantsProjectsList.length>0){
     participantsList =(this.AllParticipantsProjectsList || [])
                .filter((group: any) => group.projGrpRelationParticipantList?.length > 0)
                .flatMap((group: any) => group.projGrpRelationParticipantList);
   }

    participantsList = participantsList.filter((x:any)=>x.isChanged == true);

    if(participantsList.length>0){

       participants = participantsList.map((item:any) => ({

        participantID: item.participantId || 0,
        projectID: item.projectID || 0,
        typeOfParticipant: item.typeOfParticipant || 0,
        rucccID: item.typeOfParticipant === 1 ? item.coreID :
          item.typeOfParticipant === 2 ? item.contactID :
          item.typeOfParticipant === 3 ? item.companyID :
          item.typeOfParticipant === 4 ? item.pUserID :
          item.typeOfParticipant === 5 ? item.roleId :
          0,
        name: item.participantName || '',
        email: item.participantEmail || '',
        isEMailSent: false
      }));
    }   
  

    var ReqModel = {
      participants:participants,
      projectIDs:projectIDs,   
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),    
      officeID: this.myOfficeID
    }
   // return;
    this.loaderService.show();   
    this.coreService.addParticipantsForProjects(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.loaderService.hide();         
         
          this.AddProjectRequestsForQuickSend(projectIDs);
          
          this.toastr.success('Form has sent successfully to participants.', '', {
            timeOut: 3000,
          });
          this.dialogRef.close('Added');        
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

   async AddProjectRequestsForQuickSend(projectIDs:any) {
    try {
      var ReqModel = {
        projectIDs: projectIDs,
        coreID: Number(this.data.transactionID),
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        officeID: this.myOfficeID
      }
      const result = await this.coreService.addProjectRequests(ReqModel).toPromise();
      this.responseHolder = result;
      if (this.responseHolder.status === this.statusConstant.statusSuccess) {
      } else {
        this.loaderService.hide();
      }
    } catch (e) {
      Observable.throw(e);
    }
  }

  //  ProjectSendQuickSend(projectId:number) {
  //   var ReqModel = {
  //     folderId: 1,
  //     projectId: projectId,//this.ProjectIdForEdit,
  //     projectName: "",
  //     userID: this.currentUser.UID,
  //     organizationID: Number(this.organizationId),
  //     databaseID: Number(this.databaseId),
  //     type: 1,  // 1 Form Send , 2 Sand an Save , 3 Save Template Only 
  //     fileManagerFolderId: 0,
  //     officeID: this.myOfficeID
  //   }
  //   this.loaderService.show()
  //   this.coreService.AddProjectInfoAsTemplete(ReqModel).subscribe((response) => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
  //         this.loaderService.hide();
  //         this.AddProjectEventLog();
  //         // this.toastr.success('Form has sent successfully to participants.', '', {
  //         //   timeOut: 3000,
  //         // });           
  //       } else {
  //         this.loaderService.hide();
  //       }
  //     } else {
  //       this.loaderService.hide();
  //     }
  //   });
  // }



  //  Sequential sender
 
 
  sendFormSequentially(documents: any[], index: number) {

    if (index >= documents.length) {
      this.loaderService.hide();
      //  Pass collected projectIDs
      if (this.projectIDs.length > 1) {
        this.toastr.success('All forms have been sent successfully.', '', {
          timeOut: 3000,
        });
        this.AddProjectRequests();
      } else {
        this.toastr.success('Form have been sent successfully.', '', {
          timeOut: 3000,
        });
      }
      this.projectIDs = [];
      this.dialogRef.close('Added');
      return;
    }

    const currentItem = documents[index];
    const selectedDoc = currentItem?.selectedDocument;

    if (!selectedDoc) {
      this.sendFormSequentially(documents, index + 1);
      return;
    }

    //  Dynamic projectId (priority-based)
    const dynamicProjectId = currentItem.selectedDocument?.projectID;

    const ReqModel = {
      folderId: 1,
      projectId: dynamicProjectId,
      projectName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      type: 1,
      fileManagerFolderId: 0,
      officeID: this.myOfficeID,
      selectedDocument: selectedDoc
    };
    this.coreService.AddProjectInfoAsTemplete(ReqModel).subscribe(
      (response) => {
        if (response && response.status === this.statusConstant.statusSuccess) {
          this.projectIDs.push(dynamicProjectId);
          this.AddProjectEventLog();
          // Next form
          this.sendFormSequentially(documents, index + 1);
        } else {
          this.loaderService.hide();
          this.toastr.error(`Failed to send form ${index + 1}`);
        }
      },
      () => {
        this.loaderService.hide();
        this.toastr.error('Error occurred while sending forms.');
      }
    );
  }

  

  async AddProjectRequests() {
    try {
      var ReqModel = {
        projectIDs: this.projectIDs,
        coreID: Number(this.data.transactionID),
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        officeID: this.myOfficeID
      }
      const result = await this.coreService.addProjectRequests(ReqModel).toPromise();
      this.responseHolder = result;
      if (this.responseHolder.status === this.statusConstant.statusSuccess) {
      } else {
        this.loaderService.hide();
      }
    } catch (e) {
      Observable.throw(e);
    }
  }


 

  // To Add Project EventLog //

  async AddProjectEventLog() {
    try {
      var ReqModel = {
        projectID: this.ProjectIdForEdit,
        ipAddress: this.ipAddress,
        message: this.eventLogMessage,
        eventType: 1, //Sent=1, View=2, Sign=3, Complete=4, Decline=5, Assign=6
        device: this.device,
        browser: this.browsername,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
      }
      const result = await this.coreService.AddProjectEventLog(ReqModel).toPromise();
      this.responseHolder = result;
      if (this.responseHolder.status === this.statusConstant.statusSuccess) {
      } else {
        this.loaderService.hide();
      }
    } catch (e) {
      Observable.throw(e);
    }
  }

  // Remove Relation 
  RemoveRelation(group: any, p: any) {
    const message = `Are you sure you want to delete this participant?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          if (group !== undefined) {
            var relationListModels = [];
            var ReqModel = {
              groupRelationParticipantMappingID: group.groupRelationParticipantMappingID,
              groupID: group.groupID,
              relationColour: group.relationColour,
              contactID: null,
              relationID: group.relationID,
              projectID: p.projectID,//this.projectID
              roleID: null,
              typeOfParticipant: group.typeOfParticipant
            }
            relationListModels.push(ReqModel)

            var ReqModels = {
              relationListModels: relationListModels,
              userID: this.currentUser.UID,
              databaseID: Number(this.databaseId),
              organizationID: Number(this.organizationId),
              type: p.type,//Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
              OfficeID: this.myOfficeID
            }
            this.coreService.AddEditProjectGroupRelationParticipant(ReqModels).subscribe((response) => {
              if (response != undefined) {
                this.responseHolder = response;
                if (this.responseHolder.status == this.statusConstant.statusSuccess) {
                  this.loaderService.hide();
                  if(this.selectedTab==0){
                   this.GetAllParticipantsForProjects();
                  }else{
                   this.AddRemoveParticipant(this.getassign);
                  }                  
                  this.toastr.success('Participant removed successfully', '', {
                    timeOut: 3000,
                  });
                } else {
                  this.loaderService.hide();
                }
              } else {
                this.loaderService.hide();
              }
            });
          }
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  

  AddRemoveParticipant(document: any) {
    var ReqModel = {
      transactionID: Number(this.data.transactionID),
      documentFolderID: document.documentFolderID,
      formID: document.formID,
      formType: FormAuditType.NormalForm,
      placeholderID: document.placeholderID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
      taskID: document.taskID,
      projectID: this.projectID//document.projectID
    }
    this.loaderService.show();
    this.coreService.AddCreateProjectforPlaceholder(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.projectGroups = this.responseHolder.data.participants;//this.responseHolder.data;
          if (this.projectGroups == null) {
            this.projectGroups = [];
          }
          if (this.projectGroups.length > 0) {
            for (var i = 0, lennew = this.projectGroups.length; i < lennew; ++i) {
              var projGrpRelationParticipantList: any = [] = [];
              projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var matchRole = [];
                  matchRole = this.MatchingRole.filter((m: any) => m.roleName == projGrpRelationParticipantList[i1].relationName);
                  if (matchRole.length > 0) {
                    this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID = matchRole;
                  } else {
                    this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID = [];
                  }
                }
              }
              else {
              }
            }
          }

          if (this.projectGroups.length > 0) {
            this.ProjectIdForEdit = this.projectGroups[0].projectID;
            this.projectID = this.projectGroups[0].projectID;
          }

          // var data = [];
          // data = this.projectGroups;
          // if (data.length > 0) {
          //   this.eventLogMessage = "Sent for signature to ";
          //   var checkGroup = this.projectGroups.filter(m => m.groupType == GroupType.Group);
          //   if (checkGroup.length > 0) {
          //     var projGrpRelationParticipantList = [];
          //     projGrpRelationParticipantList = checkGroup[0].projGrpRelationParticipantList;
          //     for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
          //       var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
          //       var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
          //       var email = "";
          //       if (checkEmailAnonmous != "") {
          //         email = checkEmailAnonmous;
          //         this.eventLogMessage += '(' + email + '), ';
          //       }
          //       if (checkEmail != "") {
          //         email = checkEmail;
          //         this.eventLogMessage += '(' + email + '), ';
          //       }
          //     }
          //   }

          //   var checkViewOnly = this.projectGroups.filter(m => m.groupType == GroupType.ViewOnly);
          //   if (checkViewOnly.length > 0) {
          //     for (var i = 0, len4 = checkViewOnly.length; i < len4; ++i) {
          //       var projGrpRelationParticipantList = [];
          //       projGrpRelationParticipantList = checkViewOnly[i].projGrpRelationParticipantList;
          //       for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
          //         var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
          //         var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
          //         var email = "";
          //         if (checkEmailAnonmous != "") {
          //           email = checkEmailAnonmous;
          //           this.eventLogMessage += '(' + email + '), ';
          //         }
          //         if (checkEmail != "") {
          //           email = checkEmail;
          //           this.eventLogMessage += '(' + email + '), ';
          //         }
          //       }
          //     }
          //   }
          // }

          // this.eventLogMessage = this.eventLogMessage?.replace(/,\s*$/, "") || "";

          var check = [];
          if (this.responseHolder.data.participants == null) {
            this.responseHolder.data.participants = [];
          }
          check = this.responseHolder.data.participants.filter((x: any) => x.groupType === GroupType.Group);//this.responseHolder.data.filter((x:any) => x.groupType === 1);
          if (check.length > 0) {
            for (var i = 0, len = check.length; i < len; ++i) {
              var projGrpRelationParticipantList: any = [] = [];
              projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  if (projGrpRelationParticipantList[i1].participantEmail == null) {
                    projGrpRelationParticipantList[i1].participantEmail = '';
                  }
                  if (projGrpRelationParticipantList[i1].coreID > 0 || projGrpRelationParticipantList[i1].contactID > 0 ||
                    projGrpRelationParticipantList[i1].companyID > 0 || projGrpRelationParticipantList[i1].pUserID > 0 ||
                    projGrpRelationParticipantList[i1].roleID > 0 || projGrpRelationParticipantList[i1].participantEmail != '') {
                    // if (projGrpRelationParticipantList[i1].contactEmail != "" ||
                    //   projGrpRelationParticipantList[i1].participantEmail != "" ||
                    //   projGrpRelationParticipantList[i1].roleID != "0") {
                    this.SendButtonDisabled = true;
                    return;
                  } else {
                    this.SendButtonDisabled = false;
                    // return;
                  }
                }
              }
              else {
              }
            }
          }
        } else {
          this.loaderService.hide();
          this.projectGroups = [];
        }
      } else {
        this.loaderService.hide();
        this.projectGroups = [];
      }
    });

  }


  onSelectContact(event: MatSelectChange, relationName: any, p: any, p1: any) {
    if (event.value == p.participantName) {
      this.toastr.warning('Contact already added.', '', {
        timeOut: 3000,
      });
      return;
    }
    var getdata = this.MatchingRole.filter((s: any) => s.name == event.value && s.roleName == relationName);
    if (getdata.length > 0) {
      this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
      this.groupID = p.groupID;
      this.relationColour = "";
      this.projectID = p1.projectID;
      this.contactemail = p.contactEmail;
      this.relationID = p.relationID;
      this.peoples = [];

      this.peoples.push({
        name: getdata[0].name,
        email: getdata[0].email,
        img: "",
        coreID: 0,
        companyID: 0,
        contactID: getdata[0].contactID,
        roleID: 0,
        isShared: this.isShare,
        shortName: "",
        typeOfParticipant: 2,
      });
      if (this.peoples.length > 0) {
        this.addUpdateParticipantsNew(this.peoples,p);
      }
    }
  }



  addUpdateParticipantsNew(result: any,p:any) {
    this.peoples = [];
    this.peoples = result;

    //=== For Email ======//
    if (result[0].typeOfParticipant == 0) {
      if (this.peoples.length > 0) {
        var relationListModels: any = [] = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var req = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID: 0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 0,//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(req)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For User ======//
    if (result[0].typeOfParticipant == 4) {
      if (this.peoples.length > 0) {
        var relationListModels: any = [] = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqUser = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID: 0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: this.peoples[i].userID,
            typeOfParticipant: 4//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqUser)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For Role ======//
    if (result[0].typeOfParticipant == 5) {
      if (this.peoples.length > 0) {
        var relationListModels: any = [] = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqRole = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID: 0,
            contactEmail: null,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            userID: 0,
            roleID: this.peoples[i].roleID,
            typeOfParticipant: 5//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqRole)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For Core ======//
    if (result[0].typeOfParticipant == 1) {
      if (this.peoples.length > 0) {
        var relationListModels: any = [] = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqCore = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: this.peoples[i].coreID,
            contactID: 0,
            companyID: 0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 1//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqCore)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.addUpdateCoreToCore(relationListModels);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For Contact ======//
    if (result[0].typeOfParticipant == 2) {
      if (this.peoples.length > 0) {
        var relationListModels: any = [] = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqContact = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: this.peoples[i].contactID,
            companyID: 0,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 2//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqContact)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.addUpdateCoreToContact(relationListModels,p);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For Company ======//
    if (result[0].typeOfParticipant == 3) {
      if (this.peoples.length > 0) {
        var relationListModels: any = [] = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqCompany = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID: this.peoples[i].companyID,
            contactEmail: this.peoples[i].email,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 3//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqCompany)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.addUpateCoreToCompany(relationListModels,p);
              this.toastr.success('Participant Added successfully.', '', {
                timeOut: 3000,
              });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }
  }

  addUpdateParticipantsAutoFill(result: any,p:any) {
    this.peoples = [];
    this.peoples.push(result);

    //=== For Email ======//
    if (result.typeOfParticipant == 0) {
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var req = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID: 0,
            contactEmail: this.peoples[i].participantEmail,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 0,//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(req)
        }

        var ReqModel = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              // this.toastr.success('Participant Added successfully.', '', {
              //   timeOut: 3000,
              // });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For User ======//
    if (result.typeOfParticipant == 4) {
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqUser = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID: 0,
            contactEmail: this.peoples[i].participantEmail,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: this.peoples[i].pUserID,
            typeOfParticipant: 4//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqUser)
        }

        var ReqModels = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModels).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              // this.toastr.success('Participant Added successfully.', '', {
              //   timeOut: 3000,
              // });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For Role ======//
    if (result.typeOfParticipant == 5) {
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqRole = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID: 0,
            contactEmail: null,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            userID: 0,
            roleID: this.peoples[i].roleID,
            typeOfParticipant: 5//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqRole)
        }

        var ReqModel1 = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel1).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              // this.toastr.success('Participant Added successfully.', '', {
              //   timeOut: 3000,
              // });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For Core ======//
    if (result.typeOfParticipant == 1) {
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqCore = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: this.peoples[i].coreID,
            contactID: 0,
            companyID: 0,
            contactEmail: this.peoples[i].participantEmail,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 1//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqCore)
        }

        var ReqModel2 = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel2).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              // // this.addUpdateCoreToCore(relationListModels);
              // this.toastr.success('Participant Added successfully.', '', {
              //   timeOut: 3000,
              // });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For Contact ======//
    if (result.typeOfParticipant == 2) {
      if (this.peoples.length > 0) {
        var relationListModelsContact:any=[]=[];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqContact = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: this.peoples[i].contactID,
            companyID: 0,
            contactEmail: this.peoples[i].participantEmail,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 2//this.peoples[i].typeOfParticipant,
          }
          relationListModelsContact.push(reqContact)
        }

        var ReqModel3 = {
          relationListModels: relationListModelsContact,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel3).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.addUpdateCoreToContact(relationListModelsContact,p);
              // this.toastr.success('Participant Added successfully.', '', {
              //   timeOut: 3000,
              // });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }

    //=== For Company ======//
    if (result.typeOfParticipant == 3) {
      if (this.peoples.length > 0) {
        var relationListModels = [];
        for (var i = 0, len = this.peoples.length; i < len; ++i) {
          var reqCompany = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID: this.peoples[i].companyID,
            contactEmail: this.peoples[i].participantEmail,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 3//this.peoples[i].typeOfParticipant,
          }
          relationListModels.push(reqCompany)
        }

        var ReqModel4 = {
          relationListModels: relationListModels,
          userID: this.currentUser.UID,
          databaseID: Number(this.databaseId),
          organizationID: Number(this.organizationId),
          type: this.type,
          OfficeID: this.myOfficeID
        }
        this.loaderService.show();
        this.coreService.AddEditProjectGroupRelationParticipant(ReqModel4).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConstant.statusSuccess) {
              this.AddRemoveParticipant(this.getassign);
              this.addUpateCoreToCompany(ReqModel4,p);
              // this.toastr.success('Participant Added successfully.', '', {
              //   timeOut: 3000,
              // });
              this.peoples = [];
              this.showAddButton = false;
              this.loaderService.hide();
            }
          }
        });
      }
    }
  }


  objectList: any = [];
  typeOfParticipant: number = 0;
  showContact: boolean = true
  showRole: boolean = false;
  showSearchCore: boolean = false;
  selectCoreList: any = [];
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  stateCtrlValue: any;
  states = this.objectList;


  assignUserNew(isShare: boolean, isRole: boolean, contact: any, p: any, p1: any) {
    this.contactemail = "";
    this.showContact = true;
    this.showSearchCore = false;
    this.selectCoreList = [];

    this.isSharedAccessUserPopup = false;
    this.userSelectedList = [];
    this.sharedAccessUserList = [];

    this.stateCtrl.setValue('');

    this.typeOfParticipant = p.typeOfParticipant;
    this.type = p1.type;
    if (p1.projectID == 0) {
      this.projectID = Number(this.ProjectIdForEdit);
    } else {
      this.projectID = p1.projectID;
    }

    this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
    this.groupID = p.groupID;
    this.relationColour = p.relationColour;
    this.relationID = p.relationID;
    this.showAddButton = false;
    this.isShare = isShare;
    this.contactemail = p.contactEmail;
    this.isRolePopup = isRole;
    this.isSharedAccessRolePopup = false;
    if (isRole)
      this.currentRoleContact = contact;
    this.transRoleList = [];
    this.contactsList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.showContactRoleAddButton = false;

    const dialogRef = this.dialog.open(Add3ctypeformComponent, {
      data: {
        moduleName: "MergeForm",
        typeOfParticipant: this.typeOfParticipant,
        // sharedCoreList:this.sharedCoreList,
        // sharedContactList:this.sharedContactList,
        // sharedCompanyList:this.sharedCompanyList,     
      },
      panelClass: 'signatureModal',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.addUpdateParticipantsNew(result,p);
      }
    });
  }

  assignUserNewFromQuickSend(isShare: boolean, isRole: boolean, contact: any, p: any, p1: any) {
    this.contactemail = "";
    this.showContact = true;
    this.showSearchCore = false;
    this.selectCoreList = [];

    this.isSharedAccessUserPopup = false;
    this.userSelectedList = [];
    this.sharedAccessUserList = [];

    this.stateCtrl.setValue('');

    this.typeOfParticipant = p.typeOfParticipant;
    this.type = p1.type;
    if (p1.projectID == 0) {
      this.projectID = Number(this.ProjectIdForEdit);
    } else {
      this.projectID = p1.projectID;
    }

    this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
    this.groupID = p.groupID;
    this.relationColour = p.relationColour;
    this.relationID = p.relationID;
    this.showAddButton = false;
    this.isShare = isShare;
    this.contactemail = p.contactEmail;
    this.isRolePopup = isRole;
    this.isSharedAccessRolePopup = false;
    if (isRole)
      this.currentRoleContact = contact;
    this.transRoleList = [];
    this.contactsList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.showContactRoleAddButton = false;

    const dialogRef = this.dialog.open(Add3ctypeformComponent, {
      data: {
        moduleName: "MergeForm",
        typeOfParticipant: this.typeOfParticipant,
      },
      panelClass: 'signatureModal',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        //this.addUpdateParticipantsNew(result);
        this.AllParticipantsProjectsList;
        this.autoFillDataRuntime(result,p.relationName,p);
      }
    });
  }


  autoFillDataRuntime(result: any,relationName:any,p:any) {
    result[0].relationName=relationName;
    const autoFillList = result; // second response

    this.AllParticipantsProjectsList = this.AllParticipantsProjectsList.map((project: any) => {

      if (!project.projGrpRelationParticipantList?.length) return project;

      project.projGrpRelationParticipantList =
        project.projGrpRelationParticipantList.map((item: any) => {

          //  Check if participantEmail is blank
          const isEmailEmpty = !item.participantEmail || item.participantEmail.trim() === '';

          if (isEmailEmpty) {

            //  Find matching typeOfParticipant
            const match = autoFillList.find((x: any) => x.typeOfParticipant === item.typeOfParticipant
           && x.relationName.toLowerCase() == item.relationName.toLowerCase());

           if (match) {
              return {
                ...item,

                // Fill only if empty
                participantEmail: item.participantEmail?.trim() ? item.participantEmail : match.email,

                participantName: item.participantName?.trim() ? item.participantName : match.name,

                participantImageURL: item.participantImageURL ? item.participantImageURL: match.img,

                //  Optional extra mappings (if needed)
                coreID: item.coreID || match.coreID,
                contactID: item.contactID || match.contactID,
                companyID: item.companyID || match.companyID,
                isChanged:true
              };
            }
          }
          return item;
        });

      return project;
    });

    this.AllParticipantsProjectsList;

    var participantsList:any=[]=[];
     participantsList =(this.AllParticipantsProjectsList || [])
                .filter((group: any) => group.projGrpRelationParticipantList?.length > 0)
                .flatMap((group: any) => group.projGrpRelationParticipantList);

    var checks:any=[]=[];
    checks=participantsList.filter((x:any)=> x.participantEmail !== '');
    if(checks.length>0){
       this.SendButtonDisabledForQuickSend=false;
     }else{
       this.SendButtonDisabledForQuickSend=true;
    }
     //=== For Core ======//
    if (result[0].typeOfParticipant == 1) {       
        var relationListModels: any = [] = [];
        for (var i = 0, len = result.length; i < len; ++i) {
          var reqCore = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: result[i].coreID,
            contactID: 0,
            companyID: 0,
            contactEmail: result[i].email,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 1
          }
          relationListModels.push(reqCore)
        }
       this.addUpdateCoreToCore(relationListModels);
     }

     //=== For Contact ======//
     if (result[0].typeOfParticipant == 2) {
       var relationListModels: any = [] = [];
        for (var i = 0, len = result.length; i < len; ++i) {
          var reqContact = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: result[i].contactID,
            companyID: 0,
            contactEmail: result[i].email,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 2
          }
          relationListModels.push(reqContact)
        }
       this.addUpdateCoreToContact(relationListModels,p);
    }
     //=== For Company ======//
    if (result[0].typeOfParticipant == 3) {
      var relationListModels: any = [] = [];
        for (var i = 0, len = result.length; i < len; ++i) {
          var reqCompany = {
            groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
            groupID: this.groupID,
            coreID: 0,
            contactID: 0,
            companyID: result[i].companyID,
            contactEmail: result[i].email,
            selectedContactFieldEmailID: 0,
            relationID: this.relationID,
            relationColour: this.relationColour,
            projectID: this.projectID,
            emailFieldID: 0,
            nameFieldID: 0,
            roleID: 0,
            userID: 0,
            typeOfParticipant: 3
          }
          relationListModels.push(reqCompany)
        }
      this.addUpateCoreToCompany(relationListModels,p);
    }
  }

  // attach to Shared core
  addUpdateCoreToCore(relationListModels: any) {
    var addUpdateParticipantList: any = [] = [];
    addUpdateParticipantList = [];
    addUpdateParticipantList = relationListModels;

    const isDuplicate = this.sharedCoreList.some((item: any) => item.attachedCoreID === relationListModels[0].coreID);
    if (isDuplicate) {
      return;
    }

    if (addUpdateParticipantList.length > 0) {
      var addUpdateCoreToCoreList = [];
      addUpdateCoreToCoreList = addUpdateParticipantList.map((item: any) => ({
        attachedCoreID: item.coreID || 0,
        coreID: Number(this.data.transactionID),
      }));
      var reqModel = {
        addUpdateCoreToCoreListModel: addUpdateCoreToCoreList,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: Number(this.myOfficeID),
        databaseID: Number(this.databaseId)
      }
      this.coreService.addUpdateCoresToCore(reqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {
            this._dataSharingService.sendRefreshListFromCore(true);
            this.toastr.success('Record added successfully.', '', {
              timeOut: 3000,
            });
          }
        } else {

        }
      });
    }
  }

  // attach to shared contact
  addUpdateCoreToContact(relationListModels: any,p:any) {

    const isDuplicate = this.sharedContactList.some((item: any) => item.contactID === relationListModels[0].contactID);
    if (isDuplicate) {
      return;
    }

    let formattedArray: any[] = [];

    if (relationListModels && relationListModels.length > 0) {
      relationListModels.forEach((item: any) => {
        let obj = {
          CoreID: Number(this.data.transactionID),
          contactID: item.contactID || 0,
          email: item.email || '',
          img: item.img || '',
          isOwner: item.isOwner || false,
          isShared: item.isShared || false,
          name: item.name || '',
          roleID: item.roleID || 0,
          shortName: item.name ? item.name.charAt(0).toLowerCase() : ''
        };

        formattedArray.push(obj);
      });
    }

    var reqModel = {
      CoreID: Number(this.data.transactionID),
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      addUpdateCoreContactListModel: formattedArray,
      officeID: this.myOfficeID
    }
    this.coreService.addUpdateCoreContact(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.ContactRoleUpdate(formattedArray,p);
        //  this._dataSharingService.sendRefreshListFromCore(true);
          this.toastr.success('Record added successfully.', '', {
            timeOut: 3000,
          });
        }
      } else {

      }
    });
  }

  // attach to shared company
  addUpateCoreToCompany(relationListModels: any,p:any) {
    const isDuplicate = this.sharedCompanyList.some((item: any) => item.companyID === relationListModels[0].companyID);
    if (isDuplicate) {
      return;
    }

    let formattedArray: any[] = [];

    if (relationListModels && relationListModels.length > 0) {
      relationListModels.forEach((item: any) => {
        let obj = {
          coreID: Number(this.data.transactionID),
          companyID: item.companyID || 0,
          email: item.email || '',
          img: item.img || '',
          isShared: item.isShared || false,
          name: item.name || '',
          shortName: item.name ? item.name.charAt(0).toLowerCase() : ''
        };

        formattedArray.push(obj);
      });
    }

    var reqModel = {
      coreID: Number(this.data.transactionID),
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      addUpdateCoreContactCompanyListModel: formattedArray,
    }
    this.coreService.addUpdateCoreCompany(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
           this.CompanyRoleUpdate(formattedArray,p);
         // this._dataSharingService.sendRefreshListFromCore(true);
          this.toastr.success('Record added successfully.', '', {
            timeOut: 3000,
          });
        }
      } else {
      }
    });
  }


  selectedTab: number = 0;

  onTabChange(index: number) {
    this.selectedTab = index;
     if(this.selectedTab==0){
      this.GetAllParticipantsForProjects();
     }
     if(this.selectedTab==1){
      this.getNormalAndSharedContacts(this.data.document[0].selectedDocument, 0);
    }
  }

  ContactRoleUpdate(formattedArray:any,p:any) {
    var roles:any=[]=[];
    var obj={
      contactID: formattedArray[0].contactID,
      coreID: Number(this.data.transactionID),
      transactionalRoleName: p.relationName,
      transctionalRoleID: p.relationID
    }
    roles.push(obj);

    if (roles.length > 0) {
      var reqModel={
        databaseID: Number(this.databaseId),
        organizationID: Number(this.organizationId),
        userID: this.currentUser.UID,
        isAdded:true,
        coreContactRoleModels:roles,
        officeID:this.myOfficeID,
        sharedUserID:0,
        AddUpdateContactContactListModel:[],
        AddUpdateCoreContactCompanyListModel:[],
        AddUpdateCoreContactListModel:[],
        coreID:Number(this.data.transactionID),
      }        
      this.coreService.addUpdateCoreContactRole(reqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {  
            this._dataSharingService.sendRefreshListFromCore(true);                
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

   CompanyRoleUpdate(formattedArray:any,p:any) {
     var roles:any=[]=[];
     var obj={
      companyID: formattedArray[0].companyID,
      coreID: Number(this.data.transactionID),
      transactionalRoleName: p.relationName,
      transctionalRoleID: p.relationID
    }
    roles.push(obj);

    if (roles.length > 0) {    
      var reqModel={
       databaseID : Number(this.databaseId),
       organizationID : Number(this.organizationId),
       userID : this.currentUser.UID,
       isAdded : true,
       coreContactCompanyRoleModels : roles,
       AddUpdateCoreCompanyListModel:[],
       coreID:Number(this.data.transactionID),
      }      
      this.loaderService.show();
      this.coreService.addUpdateCoreCompanyRole(reqModel).subscribe(response => {
        if (response != undefined) {
          this.loaderService.hide();
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {  
             this._dataSharingService.sendRefreshListFromCore(true);             
          }
        } else {
          this.loaderService.hide();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

}


